






















































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import 'regenerator-runtime/runtime';
import moment from 'moment';
import InfoSection from '@/components/InfoSection.vue';
import LedgerDataTable from '@/components/LedgerDataTable.vue';
import SavingsHistory from '@/models/SavingsHistory';

@Component({
  components: { InfoSection, LedgerDataTable },
})
export default class SavingsHistoryDataTable extends Vue {
  @Prop({ default: false }) loading!: boolean;

  @State('savingsHistory') stateSavingsHistory!: SavingsHistory[];

  @Watch('stateSavingsHistory')
  onChangeStateSavingsHistory() {
    this.resetState();
  }

  availableDates: string[] = [];

  filterDate: string | null = null;

  filteredSavingsHistory: SavingsHistory[] = [];

  headers: any = [
    { text: 'Savings Date ', value: 'postingDate' },
    { text: 'Calculated ', value: 'calculatedAmount' },
    { text: 'Saved ', value: 'postedAmount' },
    { text: '', value: 'data-table-expand' },
  ];

  showDatePicker: boolean = false;

  get formattedPickerDate() {
    return this.filterDate ? this.formatDate(this.filterDate) : '';
  }

  clearDateFilter() {
    this.filteredSavingsHistory = this.stateSavingsHistory;
  }

  formatDate(dateString: string) {
    return moment(dateString).format('MMM D, YYYY');
  }

  formatMoney(money: string) {
    return `$${money}`;
  }

  formatPostedAmount(savingsHistory: SavingsHistory) {
    if (!savingsHistory.isPosted) {
      return 'Pending';
    }

    return this.formatMoney(savingsHistory.postedAmount);
  }

  isDateAvailable(date: string) {
    return this.availableDates.indexOf(date) !== -1;
  }

  populateAvailableDates() {
    this.availableDates = [];
    this.stateSavingsHistory.forEach((savingsHistory) => {
      this.availableDates.push(savingsHistory.postingDate);
    });
  }

  resetState() {
    this.showDatePicker = false;
    this.filteredSavingsHistory = this.stateSavingsHistory;
    this.populateAvailableDates();
  }

  setDateFilter() {
    if (this.filterDate === null || this.filterDate === '') {
      this.clearDateFilter();
      return;
    }

    this.filteredSavingsHistory = [];
    this.stateSavingsHistory.forEach((savingsHistory) => {
      if (savingsHistory.postingDate === this.filterDate) {
        this.filteredSavingsHistory.push(savingsHistory);
      }
    });
  }

  mounted() {
    this.resetState();
  }
}
